import api from "@/api/apiAuth";
// import router from "@/routes/index"; 

export default {
  namespaced: true,
  state() {
    return {
      clickCoin: false,
      clickExchange: false,
      subpath: "",
      openSound: false,
      alarmSound: [],
      clickGuide: false,
      soundCheck: false,
    };
  },
  mutations: {
    changeCoin(state, payload) {
      state.clickCoin = payload.state;
      // router.push('/price/favorite/fav-coin')
      // console.log("clickCoin", state.clickCoin);
      // console.log("Vue history state:", window.history);
      // console.log("Vue history state:", window.history.state);
      // console.log("history length:", window.history.length);

      // router.back()
    },
    changePath(state, value) {
      state.subpath = value;
    },
    soundOpen(state, payload) {
      state.openSound = payload.state;
    },
    changeGuide(state, payload) {
      state.clickGuide = payload.state;
    },
    checkAvail(state, payload) {
      state.soundCheck = payload.state;
    },
  },
  actions: {
    async getSoundAlarm(context) {
      try {
        const result = await api.getAlarmSound();
        context.state.alarmSound = result.data;
      } catch (error) {
        // // console.log("getRsiAlarm: ", error);
        return;
      }
    },
  },
};
